import React, { useState } from 'react';
import { Flex, Heading } from 'rebass';
import { graphql } from "gatsby";
import BorderWrapper from "../borderWrapper";
import Image from "../image";
import { pathOr, path } from "ramda";
import Container from "./container";
import Webform from "../../modules/webform";
import Bar from "../bar";
import { CONTAINER_WIDTH } from "../../utils/constants";
import { useGetFieldsByName } from "../../utils";
import { useColorMode } from "theme-ui";

const ModuleContactForm = ({ module }) => {
	const [colorMode] = useColorMode();
	const { title } = useGetFieldsByName(['title'], module, colorMode);
	const form = path(['relationships', 'webform'], module);
	const [formSubmitted, setFormSubmitted] = useState();

	return (
		<BorderWrapper flexDirection="row" justifyContent="flex-end">
			<Image
				width="100%"
				height="100%"
				sx={{ position: 'absolute', left: 0, top: 0, filter: 'blur(10px)' }}
				fluid={pathOr({}, ['relationships', 'image', 'relationships', 'file', 'localFile', 'childImageSharp', 'fluid'], module)}
			/>
			<Container justifyContent="flex-end" sx={{ zIndex: 1 }}>
				<Flex
					width="100%"
					flexDirection="column"
					alignItems="center"
					justifyContent="center"
				>
					{title ? <Heading mb={[3, null, 4, 4]} fontSize={[4, null, 5, 6]} color="white">{title}</Heading>: null}
					{form && (
						<Flex width={['100%', null, CONTAINER_WIDTH - 200, CONTAINER_WIDTH]} minHeight={[300]} py={3} alignItems="center" justifyContent="center">
							{!formSubmitted ? (
								<Webform
									color="white"
									columns={3}
									webform={form}
									endpoint={`${process.env.GATSBY_DRUPAL_BASE_URL}/gatsby_webform/submit`}
									onSuccess={() => setFormSubmitted(true)}
								/>) : (
								<Flex height="100%" flexDirection="column" alignItems="center" justifyContent="center">
									<Heading fontSize={7}>
										Merci
									</Heading>
									<Bar>on vous recontactera ;)</Bar>
								</Flex>
							)}
						</Flex>
					)}
				</Flex>
			</Container>
		</BorderWrapper>
	)
};

export default ModuleContactForm;

export const query = graphql`
    fragment moduleContactFormFragment on paragraph__module_contact_form {
        internal {
            type
        }
        title: field_title
        title_dark: field_dark_titre
        relationships {
            webform: field_webform {
                drupal_internal__id
                elements {
                    name
                    type
                    attributes {
                        name
                        value
                    }
                    options {
                        label
                        value
                    }
                }
            }
            image: field_image {
                relationships {
                    file: field_media_image {
                        localFile {
                            childImageSharp {
                                fluid(maxWidth: 1920, quality: 80) {
                                    ...GatsbyImageSharpFluid_withWebp
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;